import { Camera, Film, MapPin, BookOpen } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const SERVICES = [
  {
    icon: Camera,
    title: "Fotoğraf Çekimi",
    desc: "Doğal ışıkta, fark yaratan retouch dokunuşuyla zamansız gelin damat kareleri.",
  },
  {
    icon: Film,
    title: "Video & Sinematik",
    desc: "Fotoğraf ile aynı anda; anlarınız unutulmaz sinematik bir filme ve reels'e dönüşür.",
  },
  {
    icon: MapPin,
    title: "Ilçe Dış Çekim",
    desc: "Ankara'nın 25 ilçesinde; parktan göle, tarihi sokaklardan doğaya en iyi lokasyonlar.",
  },
  {
    icon: BookOpen,
    title: "Albüm & Baskı",
    desc: "Kareleriniz yıpranmadan bir ömür yaşasın; panoramik albüm ve kanvas seçenekleri.",
  },
];

export const Services = () => (
  <section id="hizmetler" className="section-pad bg-[#0E0F10]">
    <div className="container-lux">
      <Reveal>
        <div className="text-center max-w-2xl mx-auto">
          <span className="eyebrow justify-center">Hizmetler</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#F7F2E8] mt-3">
            Tek ekip, kusursuz bir çekim günü
          </h2>
          <p className="text-[#9A9387] mt-4">
            Düğün fotoğrafçılığından fazlası — planlamadan teslime kadar her adım aynı ekip tarafından yönetilir.
          </p>
        </div>
      </Reveal>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mt-12">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.08}>
            <div className="group h-full rounded-2xl bg-[#FBF7EF] p-6 border border-black/5 transition-shadow hover:shadow-[0_18px_40px_rgba(0,0,0,0.35)]">
              <div className="w-12 h-12 rounded-xl grid place-items-center bg-[#141517] text-[#D7B86A]">
                <s.icon className="w-6 h-6" />
              </div>
              <h3 className="font-display text-2xl text-[#141517] mt-5">{s.title}</h3>
              <p className="text-sm text-[#5B5F66] mt-2 leading-relaxed">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
